"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CombinedStore = void 0;
var functions_1 = require("../utils/functions");
var cookie_store_1 = require("./cookie.store");
var local_store_1 = require("./local.store");
var memory_store_1 = require("./memory.store");
var null_store_1 = require("./null.store");
var CombinedStore = /** @class */ (function () {
    function CombinedStore(options) {
        if (options === void 0) { options = CombinedStore.defaults; }
        var _a;
        this.cache = {};
        this.options = {};
        this.options = (0, functions_1.mergeDeep)(CombinedStore.defaults, options);
        var shouldPersist = this.options.persist !== false;
        /* Use browser localStorage is available and enabled */
        this.localStorage =
            shouldPersist && ((_a = this.options.local) === null || _a === void 0 ? void 0 : _a.fallbackEnabled) && local_store_1.LocalStore.available()
                ? new local_store_1.LocalStore()
                : new null_store_1.NullStorage();
        /* Use browser cookies */
        this.cookies =
            shouldPersist && cookie_store_1.CookieStore.available()
                ? new cookie_store_1.CookieStore(this.options.cookie)
                : new null_store_1.NullStorage();
        this.mem = new memory_store_1.MemoryStore();
    }
    Object.defineProperty(CombinedStore, "defaults", {
        get: function () {
            return {
                persist: true,
                cookie: cookie_store_1.CookieStore.defaults,
                local: local_store_1.LocalStore.defaults,
            };
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Get from Store
     * @param key Key to get
     * @returns
     */
    CombinedStore.prototype.get = function (key) {
        var _a, _b, _c;
        var value = (_c = (_b = (_a = this.localStorage.get(key)) !== null && _a !== void 0 ? _a : this.cookies.get(key)) !== null && _b !== void 0 ? _b : this.mem.get(key)) !== null && _c !== void 0 ? _c : undefined;
        if (value === undefined || value === null) {
            return value;
        }
        return this.set(key, typeof value === 'number' ? value.toString() : value);
    };
    /**
     * Set value to Store
     * @param key Key to set
     * @param value Value to store
     * @returns
     */
    CombinedStore.prototype.set = function (key, value) {
        this.localStorage.set(key, value);
        this.cookies.set(key, value);
        this.mem.set(key, value);
        return value;
    };
    /**
     * Remove item from Store
     * @param key Key to remove
     * @returns
     */
    CombinedStore.prototype.remove = function (key) {
        this.localStorage.remove(key);
        this.cookies.remove(key);
        this.mem.remove(key);
    };
    return CombinedStore;
}());
exports.CombinedStore = CombinedStore;
//# sourceMappingURL=combined.store.js.map